module.exports = __webpack_public_path__ + "static/img/banner18.4785c064.png";